import { message } from '@fuxi/eevee-ui';
import { OldTianGongRequestInstance } from 'common/service/axiosInstances';
import { DccToolSet } from '@/types/toolSetting';

const tianGong = {
  getProjectToolSets(projectId): Promise<DccToolSet[]> {
    return OldTianGongRequestInstance.get('/getLauncherConfigListByProjectID', { params: { projectId } })
      .then(({ data }) => {
        return data?.result;
      })
      .catch(e => {
        message.error(e);
      });
  },
  deleteToolSets(toolSetId) {
    return OldTianGongRequestInstance.get('/deleteLauncherConfig', {
      params: { launcherConfigId: Number(toolSetId) },
    }).then(({ data }) => {
      return data?.success;
    });
  },
  updateToolSets(toolSet) {
    return OldTianGongRequestInstance.post('/modifyLauncherConfig', {
      icon: '',
      description: '',
      ...toolSet,
      launcherConfigId: Number(toolSet.id),
    }).then(({ data }) => {
      return data?.success;
    });
  },
  addToolSets(toolSet) {
    return OldTianGongRequestInstance.post('/createLauncherConfig', { icon: '', description: '', ...toolSet }).then(
      ({ data }) => {
        return data?.success;
      },
    );
  },
  getAllLaunchers() {
    // 获取平台全量的launchers
    return OldTianGongRequestInstance.get('/getAllLaunchers')
      .then(({ data }) => {
        const launchers = data?.result;
        return launchers;
      })
      .catch(e => {
        message.error(e);
      });
  },
  getToolsSetLaunchers(toolSetId) {
    return OldTianGongRequestInstance.get('/getLauncherConfig', { params: { launcherConfigId: Number(toolSetId) } })
      .then(({ data }) => {
        const launchers = data?.result?.launchers;
        return launchers;
      })
      .catch(e => {
        message.error(e);
      });
  },
  getFileInfo(fileId) {
    return OldTianGongRequestInstance.get('/getFileInfo', { params: { fileId } }).then(({ data }) => {
      return data?.result?.url;
    });
  },
};

export default tianGong;
